<template>
  <section class="faq-section">
    <h2 class="section-title">问题解答</h2>
    <div class="faq-list">
      <div
        v-for="(item, index) in faqList"
        :key="index"
        class="faq-item"
        :class="{ expanded: activeIndex === index }"
      >
        <div class="faq-question" @click="toggle(index)">
          <span>{{ item.question }}</span>
          <span class="chevron" :class="{ up: activeIndex === index }" />
        </div>
        <div v-show="activeIndex === index" class="faq-answer">
          {{ item.answer }}
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: -1,
      faqList: [
        {
          question: "如何获得金色，银色，铜色卡牌?",
          answer:
            "官网首页通过参与盲盒获取价值NFT。金色卡牌抽奖需要支付30000RAD代币，未中将返还31500RAD代币。银色卡牌抽奖需要支付20000RAD代币，未中将返还20800RAD代币。铜色卡牌抽奖需要支付10000RAD代币，未中将返还10300RAD代币。",
        },
        {
          question: "如何参与RAD/BOX质押生态？",
          answer:
            "左侧导航进入RAD/BOX质押生态页面，质押生态最低100USDT起投，180质押和360天质押选择。选择180天质押，每日按照金本位0.3%获取RUSD收益。选择360天，每日按照金本位0.5%获取RUSD收益。",
        },
        {
          question: "卡牌的权益?",
          answer:
            "金色卡牌可获得全网收益的1%，银色卡牌可获得全网收益的0.5%，铜色卡牌可获得全网收益的0.2%。",
        },
      ],
    };
  },
  methods: {
    toggle(index) {
      this.activeIndex = this.activeIndex === index ? -1 : index;
    },
  },
};
</script>

<style lang="scss" scoped>
.faq-section {
  padding: 50px 30px 30px;
}

.section-title {
  margin: 0 0 30px;
  font-size: 50px;
  font-weight: normal;
  color: #fff;
}

.faq-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.faq-item {
  border-radius: 24px;
  background: #040a28;
  border: 1px solid rgba(115, 56, 255, 0.2);
  overflow: hidden;
}

.faq-question {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 30px;
  font-size: 26px;
  color: #fff;
  cursor: pointer;
  user-select: none;

  .chevron {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    border-right: 2px solid #fff;
    border-bottom: 2px solid #fff;
    transform: rotate(45deg);
    transition: transform 0.2s;

    &.up {
      transform: rotate(-135deg);
    }
  }
}

.faq-answer {
  padding: 0 30px 30px;
  font-size: 26px;
  line-height: 1.7;
  color: #C0C0C0;
}
</style>
